import React, { useState } from 'react'
import WizardMenu from './WizardMenu'
import { Nav, NavItem, NavLink } from 'reactstrap'
import WizardTopMenuContent from './WizardTopMenuContent';
const WizardTopMenu = () => {
    let subActiveTab_Modal = {
        "Billing Codes":7861,
        "Insurance":78601,
        "Admin":78611,
    }
    const MenuItems = WizardMenu();
    const activeTabElement = MenuItems.filter(item => item.right === true)[0];
    const [tabList, setTabsList] = useState([]);
    const [activeTab, setActiveTab] = useState(7860);
    const [subActiveTab, setSubActiveTab] = useState(subActiveTab_Modal);
   
const  handleActiceSubTab = (value,key) => {
        setSubActiveTab({...subActiveTab, [key]: value});
    }

    const handleProgressSpan = (key) => {
        let activeMenu = MenuItems.filter(item => item.key === key);
        let itemsLength = activeMenu[0]?.subCategoryItems?.length;
        let spanArray = Array.from({ length: itemsLength }, (_, index) => index + 1);
        return (
            <div className="working_status">
                {spanArray?.map((item, index) => {
                    return (<span key={item} className={`${activeMenu[0]?.subCategoryItems[index]?.isFilled==="true" ? 'active_status' : ''} ${subActiveTab[`${activeMenu[0]?.name}`] === activeMenu[0]?.subCategoryItems[index]?.key ? 'process' : '' }`}></span>)
                })}
            </div>
        )
    }
    const handleActiveTab = (item) => {
        const { key, name, right } = { ...item };
        let dynamicTabs = [...tabList];
        if (tabList.length === 0) {
            let obj = {
                name: activeTabElement.name,
                key: activeTabElement.key,
                right: activeTabElement.right,
            }
            dynamicTabs.push(obj);
        }
        let newObj = {
            key: key,
            name: name,
            right: right,
        }
        let tabExist = tabList.filter(item => item?.name === name);
        // let selected_Item_List = MenuItems.filter(item => item.key === key);
        // let activeSubtab = selected_Item_List[0]?.subCategoryItems[0]?.key;
        // console.log("ACTIVESUBTAB",activeSubtab)
        if (!(tabExist && tabExist.length > 0)) {
            dynamicTabs = [...dynamicTabs, newObj]
            setTabsList(dynamicTabs)
        }
        if (activeTab !== key) {
            setActiveTab(key);
        }
    }
    return (
        <div>
            <Nav className="row status border-end-0">
                {MenuItems && MenuItems?.map((item) => {
                    return (
                        <React.Fragment key={item.key}>
                            <NavItem onClick={() => handleActiveTab(item)} className="col-md-4 p-0 br-right-1 br-clr">
                                <NavLink href='#' className={activeTab === item.key ? "in_progress" : ""}>
                                    <div className="">
                                        <p className="heading">Pending</p>
                                        <div className='d-flex align-items-center gap-2'>
                                            <p className="heading sm">{item?.name}</p>
                                            {activeTab === item.key ? (
                                                handleProgressSpan(activeTab)
                                            ) : (<></>)}
                                        </div>

                                        <p className="text">Setup your practice info</p>
                                    </div>
                                </NavLink>
                            </NavItem>
                        </React.Fragment>
                    )
                })}
            </Nav>
            <WizardTopMenuContent dynamicTabs={tabList} activeTab={activeTab} handleActiceSubTab={handleActiceSubTab}/>
        </div>
    )
}

export default WizardTopMenu
